import styled from 'styled-components';
import { Column, Row, constants } from '@narvar/nth-grid';

export const FormRow = styled(Row)`
  & + & {
    @media (min-width: ${constants.breakpointMinWidths[constants.WIDTH_SM]}) {
      margin-top: 1rem;
    }
  }
`;

export const ActionsRow = styled(Row)`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: ${constants.breakpointMinWidths[constants.WIDTH_SM]}) {
    flex-direction: row;
    margin-top: 2rem;
  }
`;

export const FormColumn = styled(Column)`
  margin-bottom: 1.5rem;
  @media (min-width: ${constants.breakpointMinWidths[constants.WIDTH_SM]}) {
    margin-bottom: 0;
  }
`;

export const UpsLogoWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: ${constants.breakpointMinWidths[constants.WIDTH_SM]}) {
    margin-top: 1rem;
  }
`;

export const UpsLogo = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  margin-right: 0.125rem;
  background-image: url('https://assets.narvar.com/carriers/ups.png');
  background-size: contain;
  background-repeat: no-repeat;
`;

export const LasershipLogoWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: ${constants.breakpointMinWidths[constants.WIDTH_SM]}) {
    margin-top: 1rem;
  }
`;

export const LasershipLogo = styled.div`
  height: 2rem;
  width: 6rem;
  margin-left: 0.25rem;
  background-image: url('https://assets.narvar.com/carriers/lasership.png');
  background-size: contain;
  background-repeat: no-repeat;
`;

export const OnTracLogo = styled.div`
  height: 0.93375rem;
  width: 4.75rem;
  margin-left: 0.25rem;
  background-image: url('https://assets.narvar.com/carriers/ontrac.svg');
  background-size: contain;
  background-repeat: no-repeat;
`;
